import { AlertCircle, AlertTriangle } from "lucide-react";
import { Badge } from "@/components/ui";
import * as React from "react";

interface Props {
  blockedWords: string[];
  flaggedWords: string[];
}

export const DetectedPhraseAlert = ({ blockedWords, flaggedWords }: Props) => {
  return blockedWords.length > 0 ? (
    <div className="flex items-center gap-2 p-2 px-3 bg-red-50 border border-red-100 rounded-xl animate-in fade-in slide-in-from-top-1 duration-300 shrink-0">
      <AlertCircle className="size-4 text-red-600 shrink-0" />
      <div className="flex items-center gap-2 overflow-hidden">
        <span className="text-[11px] font-bold text-red-700 uppercase tracking-tight shrink-0">
          Blocked Phrase{blockedWords.length > 1 ? "s" : ""}:
        </span>
        <div className="flex flex-wrap gap-1">
          {blockedWords.map(word => (
            <Badge key={word} variant="destructive" className="px-1.5 py-0 h-4 text-[10px] font-bold uppercase">
              {word}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  ) : flaggedWords.length > 0 ? (
    <div className="flex items-center gap-2 p-2 px-3 bg-amber-50 border border-amber-100 rounded-xl animate-in fade-in slide-in-from-top-1 duration-300 shrink-0">
      <AlertTriangle className="size-4 text-amber-600 shrink-0" />
      <div className="flex items-center gap-2 overflow-hidden">
        <span className="text-[11px] font-bold text-amber-700 uppercase tracking-tight shrink-0">
          Flagged Phrase{flaggedWords.length > 1 ? "s" : ""}:
        </span>
        <div className="flex flex-wrap gap-1">
          {flaggedWords.map(word => (
            <Badge
              key={word}
              variant="outline"
              className="px-1.5 py-0 h-4 text-[10px] font-bold uppercase bg-amber-100 text-amber-700 border-amber-200"
            >
              {word}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  ) : undefined;
};
